import axios from 'axios';

export const getAnnouncementsList = () => axios.get('/common/management/announcements/');

export const createAnnouncement = data => axios.post('/common/management/announcements/', data);

export const getAnnouncementDetail = id => axios.get(`/common/management/announcements/${id}/`);

export const updateAnnouncement = (id, data) => axios.put(`/common/management/announcements/${id}/`, data);

export const deleteAnnouncement = id => axios.delete(`/common/management/announcements/${id}/`);

export const toggleAnnouncement = id => axios.put(`/common/management/announcements/${id}/toggle/`);
